//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import ReactAngularWidget from '@react-bridge/react-angular-widget';

export class ProcessingVideo extends ReactAngularWidget {
  public html(): string {
    return `<processing-video class="{{ className }}"></processing-video>`;
  }
}
